import { AbstractControl } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class UalaAddressAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'Alias incorrecto, debe ser por ejemplo: ramoncito2000'
        },
        'en-US': {
            bad_email: 'Incorrect Alias, here`s an example: ramoncito2000'
        }
    };
    protected static label: any = {
        'es-AR': 'Alias de',
        'en-US': 'Alias for'
    };
    protected static placeholder: any = {
        'es-AR': 'Por ejemplo: ramoncito2000',
        'en-US': 'For example: ramoncito2000'
    };
    public getLabelToAccountType(): string {
        return UalaAddressAccountValidator.label[UalaAddressAccountValidator.lang] ?? UalaAddressAccountValidator.label['es-AR'];
    }

    public getPlaceholderToAccountType(): string {
        return (
            UalaAddressAccountValidator.placeholder[UalaAddressAccountValidator.lang] ?? UalaAddressAccountValidator.placeholder['es-AR']
        );
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any =
            UalaAddressAccountValidator.errors[UalaAddressAccountValidator.lang] ?? UalaAddressAccountValidator.errors['es-AR'];
        if (/^[a-zA-Z0-9][a-zA-Z0-9\_\-\.]{2,40}$/.test(control.value)) {
            return null;
        }

        return { forbiddenName: error.bad_email };
    }
}
